<template>
  <div class="ll-cancel-popup-content">
    <p
      v-if="cancelText"
      class="ll-cancel-popup-content_text"
    >
      {{ $t(cancelText) }}
    </p>
    <slot />
    <div class="buttons">
      <slot name="buttons" />
    </div>
  </div>
</template>
<script>
export default {
  name: "LlCancelPopupContent",
  props: {
    cancelText: {
      type: String,
      default: "",
    },
  },
};
</script>
<style lang="scss">
@import "@/assets/scss/component/ll-cancel-popup-content";
</style>